import React from 'react'

const Service = () => {
  return (
    <>
<section>
    <div class="st-height-b100 st-height-lg-b80"></div>
    <div class="container">
      <div class="st-section-heading st-style1">
        <h4 class="st-section-heading-title">SERVICES</h4>
        <h2 class="st-section-heading-subtitle">SERVICES</h2>
      </div>
      <div class="st-height-b25 st-height-lg-b25"></div>
    </div>
    </section>
    </>
  )
}

export default Service
